module.exports = __webpack_public_path__ + "img/ic_screen_share_mute.8424621d.svg";